import React, { useState, useEffect,useRef   } from 'react';
import { Box, Button, Breadcrumbs, Typography, Select, MenuItem,InputAdornment, TextField, FormControl, InputLabel, IconButton, Popover } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getRoomMasterdropdata, GetPropWiseBedCalendarMonth } from '../../../../Api/PropertyMst/Api';
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { getFormMode } from "../../../../lib/helpers";
import TableComponent from "../../../../atoms/TableComponent/NewTableBedcalender";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import dayjs from 'dayjs';
import SearchIcon from "@mui/icons-material/Search";
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import axiosInstance from '../../../../lib/axios';
import { 
  selectProperties, 
  selectGlobalProperty,
  selectLocalProperty,
  setLocalProperty,
  fetchProperties,
  selectPropertyStatus
} from '../../../../redux/propertySlice';

const Form_Mode = getFormMode();

const BASE_COLUMNS = [
  { id: 'RoomNo', label: 'RoomNo', minWidth: 30, align: 'left' },
  { id: 'RoombedName', label: 'BedNo', minWidth: 30, align: 'start' },
  { id: 'RoomTypeName', label: 'RType', minWidth: 30, align: 'center' },
  { id: 'RoomBedTypeName', label: 'BType', minWidth: 30, align: 'center' },
  { id: 'RoomViewNAme', label: 'View', minWidth: 30, align: 'center' },
  { id: 'BedRent', label: 'Rent', minWidth: 30, align: 'center' },
  { id: 'FloorName', label: 'Floor', minWidth: 30, align: 'center' },
];

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default function GenerateCalender() {
  const userId = sessionStorage.getItem('UserId');
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(1000);
  const [searchTerms, setSearchTerms] = useState({});
  const [rows, setRows] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [currentYear, setCurrentYear] = useState(dayjs().year());
    const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 1000,
    totalRecords: 0,
    totalPages: 0
  });
  const [searchText, setSearchText] = useState('');
  const searchTimeoutRef = useRef(null);
  const [selectedRange, setSelectedRange] = useState({
    from: null,
    to: null,
    selecting: 'from'
  });
  const [isLoading, setIsLoading] = useState(false);
  const [columns, setColumns] = useState(BASE_COLUMNS);
  const [form, setForm] = useState({ PropId: "" });
  const [anchorEl, setAnchorEl] = useState(null);
  const permissions = usePermissions("Generate Calender");
    const dispatch = useDispatch();
    const properties = useSelector(selectProperties);
    const globalProperty = useSelector(selectGlobalProperty);
    const localProperty = useSelector(state => selectLocalProperty(state, 'calendar'));
    const propertyStatus = useSelector(selectPropertyStatus);
    const selectedProperty = localProperty || globalProperty;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'date-range-popover' : undefined;
  

  useEffect(() => {
    // const fetchDropdownData = async () => {
    //   try {
    //     const response = await getRoomMasterdropdata({ Flag: "", UserId: userId });
    //     if (response?.data?.Status === 0) {
    //       const dropdownItems = response.data.Data.map(item => ({ id: item.PropId, name: item.Name }));
    //       setDropdownData(dropdownItems);
    //       if (dropdownItems.length > 0) {
    //         setSelectedValue(dropdownItems[0].id);
    //         setForm(prev => ({ ...prev, PropId: dropdownItems[0].id }));
    //       }
    //     }
    //   } catch (error) {
    //     toast.error("Error fetching property data");
    //   }
    // };
    // fetchDropdownData();
  }, [userId]);

  const handleYearChange = (increment) => {
    setCurrentYear(prev => prev + increment);
  };

  const handleMonthClick = (monthIndex) => {
    const date = dayjs().year(currentYear).month(monthIndex).startOf('month');
    
    if (selectedRange.selecting === 'from') {
      setSelectedRange({
        from: date,
        to: null,
        selecting: 'to'
      });
    } else {
      if (!selectedRange.from) {
        setSelectedRange({
          from: date,
          to: null,
          selecting: 'to'
        });
        return;
      }

      const monthsDiff = date.diff(selectedRange.from, 'month');
      if (monthsDiff > 12) {
        toast.error("Maximum 12 months range allowed");
        return;
      }

      if (date.isBefore(selectedRange.from)) {
        setSelectedRange({
          from: date,
          to: null,
          selecting: 'to'
        });
      } else {
        setSelectedRange({
          from: selectedRange.from,
          to: date,
          selecting: 'from'
        });
        handleClose();
      }
    }
  };

  const generateColumns = () => {
    if (!selectedRange.from || !selectedRange.to) return BASE_COLUMNS;

    const years = [];
    let currentYear = selectedRange.from.year();
    const endYear = selectedRange.to.year();

    while (currentYear <= endYear) {
      years.push(currentYear);
      currentYear++;
    }

    const newColumns = [...BASE_COLUMNS];
    
    years.forEach(year => {
      // Add year column with YearNm from API
      newColumns.push({
        id: `year_${year}`,
        label: year.toString(),
        minWidth: 25,
        align: 'center',
        isYear: true
      });

      const startMonth = year === selectedRange.from.year() ? selectedRange.from.month() : 0;
      const endMonth = year === selectedRange.to.year() ? selectedRange.to.month() : 12;

      for (let month = startMonth; month <= endMonth; month++) {
        newColumns.push({
          id: `${month + 1}_${year}`,
          label: MONTHS[month],
          minWidth: 25,
          align: 'center'
        });
      }
    });

    return newColumns;
  };
 const fetchCalendarData = async (page = 1, search = '') => {
  
    if (!selectedProperty || !selectedRange.from || !selectedRange.to) {
      toast.warning("Please select property and date range");
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        PropId: parseInt(selectedProperty),
        BookDtFrom: selectedRange.from.format('YYYY-MM-DD'),
        CheckoutDt: selectedRange.to.format('YYYY-MM-DD'),
        Flag: "PBL",
        currentPage: page,
        PageSize: pagination.pageSize,
        SearchText: search
      };

      const response = await GetPropWiseBedCalendarMonth(payload);
      
      if (response?.data?.Status === 0 && response.data.Data) {
        const transformedData = transformCalendarData(response.data.Data);
        setRows(transformedData);
        setColumns(generateColumns());
        
        // Update pagination from API response
        setPagination(prev => ({
          ...prev,
          currentPage: response.data.PageData?.PageNumber || 1,
          totalRecords: response.data.PageData?.TotalRecords || 0,
          totalPages: response.data.PageData?.TotalPages || 1
        }));
      } else {
        setRows([]);
        setPagination(prev => ({
          ...prev,
          totalRecords: 0,
          totalPages: 0
        }));
      }
    } catch (error) {
      toast.error("Error fetching calendar data");
    } finally {
      setIsLoading(false);
    }
  };

  // Add search handler with debounce
  const handleSearchChange = (value) => {
    setSearchText(value);
    
    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    
    // Only search if at least 3 characters or empty
    if (value.length >= 3 || value.length === 0) {
      searchTimeoutRef.current = setTimeout(() => {
        fetchCalendarData(1, value);
      }, 1000);
    }
  };

  // Add pagination handler
  const handlePageChange = (newPage) => {
    fetchCalendarData(newPage, searchText);
  };

  // Add rows per page handler
  const handleRowsPerPageChange = (newPageSize) => {
    setPagination(prev => ({
      ...prev,
      pageSize: newPageSize,
      currentPage: 1
    }));
    fetchCalendarData(1, searchText);
  };

  // useEffect(() => {
  //   if (selectedProperty && selectedRange.from && selectedRange.to) {
  //     fetchCalendarData("");
  //   }
  // }, [selectedProperty, selectedRange.from, selectedRange.to]); 

  const transformCalendarData = (apiData) => {
    const transformedData = [];
    const groupedData = {};
    
    apiData.forEach(item => {
      if (item.BedStatus !== 'P') return;
      
      const key = `${item.RoomNo}_${item.RoombedName}`;
      if (!groupedData[key]) {
        groupedData[key] = {
          RoomNo: item.RoomNo,
          RoombedName: item.RoombedName,
          RoomTypeName: item.RoomTypeName,
          RoomBedTypeName: item.RoomBedTypeName,
          RoomViewNAme: item.RoomViewNAme,
          BedRent: item.BedRent,
          FloorName: item.FloorName
        };
      }
      
      const monthKey = `${item.MonthId}_${item.YearNm}`;
      groupedData[key][monthKey] = 'P';
      groupedData[key][`year_${item.YearNm}`] = item.YearNm; // Add YearNm to display year
    });
    
    return Object.values(groupedData);
  };

  const handleGenerateCalendar = async () => {
    if (!selectedProperty || !selectedRange.from || !selectedRange.to) {
      toast.warning("Please select property and date range");
      return;
    }

    setIsLoading(true);
    try {
      // Main payload for generating calendar
      const payload = {
        PropId: parseInt(selectedProperty),
        BookDtFrom: selectedRange.from.format('YYYY-MM-DD'),
        CheckoutDt: selectedRange.to.format('YYYY-MM-DD'),
        Flag: "PBG"
      };

      // First call the main API to generate the calendar
      const response = await GetPropWiseBedCalendarMonth(payload);
      
      if (response?.data?.Status === 1) {
        // Prepare payloads for the additional APIs
        const bedCatPayload = {
          PropId: parseInt(selectedProperty),
          Flag: ""
        };

        const bedCatCalPayload = {
          PropId: parseInt(selectedProperty),
          BookDtFrom: selectedRange.from.format('YYYY-MM-DD'),
          CheckoutDt: selectedRange.to.format('YYYY-MM-DD'),
          Flag: ""
        };

        // Call all 4 additional APIs
        try {
          // InsertBedCat API
          await axiosInstance.post(
            `BedCalendar/InsertBedCat`,
            bedCatPayload
          );

          // InsertBedCatCal API
          await axiosInstance.post(
            `BedCalendar/InsertBedCatCal`,
            bedCatCalPayload
          );

          // UpdateBedCat API
          await axiosInstance.post(
            `BedCalendar/UpdateBedCat`,
            bedCatPayload
          );

          // UpdateBedCatCal API
          await axiosInstance.post(
            `BedCalendar/UpdateBedCatCal`,
            bedCatCalPayload
          );

          toast.success("Calendar generated and all related data updated successfully");
          fetchCalendarData();
        } catch (apiError) {
          console.error('Error in additional API calls:', apiError);
          toast.warning("Calendar generated but some updates failed");
        }
      } else {
        toast.error(response?.data?.Message || "Failed to generate calendar");
      }
    } catch (error) {
      console.error('Error generating calendar:', error);
      toast.error("Error generating calendar");
    } finally {
      setIsLoading(false);
    }
};

  const handleDropdownChange = (event) => {
    const selectedId = event.target.value;
    dispatch(setLocalProperty({
      componentId: 'calendar',
      propertyId: selectedId
    }));
    setForm(prevForm => ({ ...prevForm, PropId: selectedId }));
  };
  

  const Filters = (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
          <TextField
          placeholder="Search..."
          variant="outlined"
          size="small"
          value={searchText}
          onChange={(e) => handleSearchChange(e.target.value)}
          sx={{ 
            width: "200px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              backgroundColor: "#f9f9f9",
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />

        <FormControl sx={{ minWidth: 170 }}>
          <InputLabel id="property-select-label">Property</InputLabel>
          <Select
            labelId="property-select-label"
            value={selectedProperty || ''} 
            onChange={handleDropdownChange}
            label="Property"
            sx={{ height: "40px" }}
          >
            {properties.map((item) => ( // Use Redux properties
            <MenuItem key={item.Id} value={item.Id}>{item.Name}</MenuItem>
          ))}
          </Select>
        </FormControl>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <TextField
            onClick={handleClick}
            value={
              selectedRange.from 
                ? `${selectedRange.from.format('MMM YYYY')} - ${
                    selectedRange.to ? selectedRange.to.format('MMM YYYY') : 'Select end date'
                  }`
                : 'Select date range'
            }
            InputProps={{ 
              readOnly: true,
              sx: { 
                height: "40px",
                width: "180px",
                cursor: "pointer",
                "& input": {
                  textAlign: "center"
                }
              } 
            }}
          />

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            sx={{
              "& .MuiPopover-paper": {
                width: "300px",
                p: 2
              }
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
              {/* Year navigation - centered */}
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
                <IconButton onClick={() => handleYearChange(-1)} size="small">
                  <ChevronLeft />
                </IconButton>
                <Typography variant="h6">{currentYear}</Typography>
                <IconButton onClick={() => handleYearChange(1)} size="small">
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Month selection - centered */}
              <Box sx={{ 
                display: "grid", 
                gridTemplateColumns: "repeat(4, 1fr)", 
                gap: 1,
                width: "100%",
                justifyContent: "center"
              }}>
                {MONTHS.map((month, index) => (
                  <Button
                    key={month}
                    variant="outlined"
                    size="small"
                    onClick={() => handleMonthClick(index)}
                    sx={{
                      minWidth: 0,
                      width: "100%",
                      height: 30,
                      fontSize: '0.75rem',
                      backgroundColor: 
                        selectedRange.from?.month() === index && selectedRange.from?.year() === currentYear
                          ? '#635bff' 
                          : selectedRange.to?.month() === index && selectedRange.to?.year() === currentYear
                          ? '#635bff'
                          : 'inherit',
                      color: 
                        (selectedRange.from?.month() === index && selectedRange.from?.year() === currentYear) ||
                        (selectedRange.to?.month() === index && selectedRange.to?.year() === currentYear)
                          ? 'white'
                          : 'inherit'
                    }}
                  >
                    {month}
                  </Button>
                ))}
              </Box>
            </Box>
          </Popover>
        </Box>

        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
  variant="contained"
  onClick={() => {
    fetchCalendarData();
  }}
  sx={{ height: "40px", whiteSpace: "nowrap", backgroundColor: "#635bff" }}
>
  Show Pending
</Button>
          <Button
            variant="contained"
            onClick={handleGenerateCalendar}
            sx={{ height: "40px", whiteSpace: "nowrap", backgroundColor: "#635bff" }}
          >
            Generate
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      <Box sx={{ maxWidth: "100vw", overflowX: "hidden" }}>
        <TableComponent
          // page={page}
          title="Property"
          titleMaster="Bed Calendar"
          columns={columns}
          rows={rows}
          disableSelection={true}
           page={pagination.currentPage - 1} 
          rowsPerPage={pagination.pageSize}
          handleChangePage={(e, newPage) => handlePageChange(newPage + 1)}
          handleChangeRowsPerPage={(e) => handleRowsPerPageChange(parseInt(e.target.value))}
          pagination={pagination}
          FiltersJsx={Filters}
          filteredRows={rows}
          // rowsPerPage={rowsPerPage}
          handleSearchChange={(col, val) => setSearchTerms(prev => ({ ...prev, [col]: val }))}
          // handleChangePage={(e, newPage) => setPage(newPage)}
          // handleChangeRowsPerPage={(e) => {
          //   setRowsPerPage(+e.target.value);
          //   setPage(0);
          // }}
          handleLocationclick={() => navigate('/masters/property')}
          handleHomeClick={() => navigate('/dashboard')}
          cellStyle={(columnId) => 
            columnId.startsWith('year_') 
              ? { 
                  padding: '0px', 
                  fontSize: '12px', 
                  fontWeight: 'bold', 
                  textAlign: 'start',
                  backgroundColor: '#f0f0f0'
                }
              : /^\d+_\d+$/.test(columnId)
              ? { 
                  padding: '0px', 
                  fontSize: '10px', 
                  textAlign: 'start',
                  minWidth: '25px'
                }
              : {}
          }
          isLoading={isLoading}
        />
      </Box>
    </>
  );
}